import { $, $$, on, lockScroll, unlockScroll } from '../core/dom.js';
import { initRequestForm } from './requestForm.js';
import { initGenTabs } from './tabs.js';
import { SUBMISSIONS_OPEN } from '../core/config.js';

let overlay;

export function initGenerations() {
  // Styrer "kommer snart"-visningen (se SUBMISSIONS_OPEN i core/config.js)
  document.documentElement.classList.toggle('submissions-closed', !SUBMISSIONS_OPEN);

  overlay = $('#generations');
  if (!overlay) return;

  initGenTabs(overlay);
  initRequestForm();

  $$('[data-open-generations]').forEach(btn =>
    on(btn, 'click', e => { e.preventDefault(); open(); })
  );
  on($('#gen-close'), 'click', close);
  on(document, 'keydown', e => {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
  });

  // Direkte link: dmunion.dk/#generations åbner overlayet
  if (location.hash === '#generations') open();
}

function open() {
  overlay.classList.add('is-open');
  lockScroll();
}

function close() {
  overlay.classList.remove('is-open');
  unlockScroll();
  if (location.hash === '#generations') history.replaceState(null, '', location.pathname);
}
